export default __webpack_public_path__ + "static/media/desktop-feature-2.e2721523.png";